<template>
    <div class="process-detail">
        <iframe class="detailUrl-page" :src="detailUrl" frameborder="0"></iframe>
    </div>
</template>

<script>
    import { getProcessViewUrl, getProcessViewDiagramUrl, getProcessHistoryViewUrl } from '@/data-model';
    export default {
        data () {
            return {
                detailUrl: ''
            };
        },
        props: {
            viewParams: {
                type: Object
            }
        },
        methods: {
            setProcessState (viewParams) {
                let url;
                if (viewParams.pModelId) {
                    url = getProcessHistoryViewUrl(this.viewParams.id + ';' + this.viewParams.pModelId);
                } else {
                    if (viewParams.viewDiagram) {
                        url = getProcessViewDiagramUrl(this.viewParams.id);
                    } else {
                        url = getProcessViewUrl(this.viewParams.id);
                    }
                }
                this.detailUrl = url;
                // let tempwindow = window.open();
                // tempwindow.location = this.detailUrl;
            }
        }
    };
</script>

<style lang="less">
    .process-detail {
        height: 1100px;
        display: flex;
        // margin-top: -2%;
        margin-top: 2%;
        .detailUrl-page {
            flex: 1;
            width: 100%;
            // height: 900px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/ProcessList/ProcessDetailView.vue